module.exports = __webpack_public_path__ + "static/media/importICS1.75c3afae.png";